if ($(window).width() < 960) {
    $(window).on("scroll", function() {
        if($(window).scrollTop() > 50) {
            $(".header-container").addClass("is-fixed");
            $("#navbarToggle").addClass("toggle-fixed");
            $('.navbar-secondary').css('display', 'flex');
        } else {
            //remove the background property so it comes transparent again (defined in your css)
            $(".header-container").removeClass("is-fixed");
            $('.navbar-secondary').hide();
        }
    });
}
else {
    // if($('.site-header').hasClass('bio-detail')) {
    //     $(".site-header").addClass("bg-white");
    // }
    $(window).on("scroll", function() {
        if($(window).scrollTop() > 50) {
            $(".header-container").addClass("is-fixed");
        } else {
            //remove the background property so it comes transparent again (defined in your css)
            $(".header-container").removeClass("is-fixed");
        }
    });
}